module.exports = __webpack_public_path__ + "d22b6c16e73519927ea8b317d41dabe2.svg";